<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <div class="sidebar__heading">
        <h3 class="sidebar__title">Topic Information</h3>
        <span @click="closeEventbox()"
          ><svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            /></svg
        ></span>
      </div>
      <div class="events__presenter">
        <div v-for="event in events" :key="event.title">
          <h2>{{ event.events_title }}</h2>
          <div class="events__presenter-person">
            Presented by:
            <p>{{ event.events_presenter }}</p>
          </div>
          <div class="events__presenter-time">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="starttime">{{
              event.events_start_time | onlyTime
            }}</span>
            -
            <span class="endtime">{{ event.events_end_time | onlyTime }}</span>
            (UTC timezone)
          </div>
          <div class="events__presenter-time">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="starttime">{{ event.event_start_nepal_time }}</span>
            -
            <span class="endtime">{{ event.event_end_nepal_time }}</span>
            (NPT timezone)
          </div>
          <div class="events__presenter-abstract">
            <span>Abstract of the talk:</span>
            <p>
              {{ event.events_abstract }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  name: "SideEventbar",
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  methods: {
    closeEventbox() {
      bus.$emit("closeSideboxEvent");
      document.body.classList.remove("overflow-fix");
    },
  },
  filters: {
    onlyDate: function(value) {
      return value.split(",")[0];
    },
    onlyTime: function(value) {
      return value.split(" ")[4].substring(0, 5);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  margin: 0rem 0rem 1rem;
  color: var(--primary-color);
}
.sidebar {
  max-width: 550px;
  margin-left: auto;
  background-color: var(--bg-black);
  box-sizing: border-box;
  color: var(--text-white);
  overflow: auto;
}
.sidebar-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.69);
}
.sidebar__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 999;
  padding: 2rem;
  background-color: var(--bg-black);
}
.sidebar__heading span {
  cursor: pointer;
}
.events__presenter{
  position: relative;
  padding: 0 2rem 2rem 2rem;
}

.events__presenter-person {
  display: flex;
  color: var(--lighter-grey);
}
.events__presenter-time {
  color: var(--lighter-grey);
  display: flex;
  align-items: center;
  margin-top: 0.6rem;
}
.events__presenter-abstract span {
  color: var(--lighter-grey);
  margin-bottom: 0.3rem;
  display: block;
}
.events__presenter svg {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.3rem;
}
.events__presenter-time span {
  color: var(--text-white);
}
.events__presenter-person p {
  color: var(--text-white);
}
.events__presenter-time span :first-child {
  margin-right: 20px;
}
.events__presenter-abstract {
  margin-top: 1.5rem;
}
@media (max-width: 576px) {
  .sidebar {
    width: 100%;
    max-width: 100%;
  }
}
</style>
